import { render, staticRenderFns } from "./PlayerConfig.vue?vue&type=template&id=348beb21&scoped=true&"
import script from "./PlayerConfig.vue?vue&type=script&lang=js&"
export * from "./PlayerConfig.vue?vue&type=script&lang=js&"
import style0 from "./PlayerConfig.vue?vue&type=style&index=0&id=348beb21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348beb21",
  null
  
)

export default component.exports